import React from 'react';
import useIsBrowser from '@docusaurus/useIsBrowser';
import clsx from 'clsx';
import IconDarkMode from './dark-mode-icon.svg';
import IconLightMode from './light-mode-icon.svg';

export interface ColorModeToggleProps {
  className?: string;
  value: 'light' | 'dark';
  onChange: (value: 'light' | 'dark') => void;
}

function ColorModeToggle({ className, value, onChange }: ColorModeToggleProps) {
  const isBrowser = useIsBrowser();
  const nextMode = value === 'dark' ? 'light' : 'dark';
  const title = `Switch to ${nextMode} mode`;

  return (
    <div className={className}>
      <button
        type="button"
        disabled={!isBrowser}
        aria-label={title}
        title={title}
        onClick={() => onChange(nextMode)}
        className={clsx('p-2 rounded-full bg-background-subtle', !isBrowser && 'cursor-not-allowed')}
      >
        {value === 'dark' ? (
          <IconDarkMode className="w-5 h-5 text-icon" />
        ) : (
          <IconLightMode className="w-5 h-5 text-icon" />
        )}
      </button>
    </div>
  );
}

export default React.memo(ColorModeToggle);
